import { Lightning } from '@lightningjs/sdk';
import { BAR_WIDTH, colors, defaultContext, GAP, getInitialStyle, HEIGHT, WIDTH } from './bars.style';

export class Bars extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  _attach() {
    this._style = defaultContext;
    const { screenSize, colorMode } = this._style;
    const h = HEIGHT[screenSize];
    const w = BAR_WIDTH[screenSize];
    const gap = GAP[screenSize];

    const children = [];
    for (let i = 0; i < 4; i += 1) {
      children.push({
        ref: `Bar${i}`,
        rect: true,
        w,
        h,
        x: i * (w + gap),
        y: h,
        mountY: 1,
        color: colors.bar[colorMode],
      });
    }

    this.patch({
      children,
      w: WIDTH[screenSize],
    });

    this._timeouts = {};
  }

  _detach() {
    this.stop();
    this._timeouts = null;
    this._style = null;
  }

  start() {
    this.children.forEach(child => {
      this._startBarAnimation(child);
    });
  }

  stop(displayMinimalLevel = false) {
    this.children.forEach(child => {
      this._stopBarAnimation(child);
      child.setSmooth('h', displayMinimalLevel ? 1 : 0);
    });

    if (this._timeouts) {
      Object.keys(this._timeouts).forEach(key => {
        clearTimeout(this._timeouts[key]);
        this._timeouts[key] = null;
      });
    }
  }

  _startBarAnimation(bar) {
    const height = HEIGHT[this._style.screenSize];

    bar.transition('h').on('finish', () => {
      const timeout = setTimeout(() => bar.setSmooth('h', Math.round(Math.random() * height)), 16);
      this._timeouts[bar.ref] = timeout;
    });

    bar.setSmooth('h', Math.round(Math.random() * height));
  }

  _stopBarAnimation(bar) {
    const transition = bar.transition('h');
    if (transition) {
      transition.stop();
      transition.removeAllListeners('finish');
    }
  }
}
